import { QuestResultFormatEnum } from 'sandpiper_api';

const questResultFormat = new QuestResultFormatEnum();

export default {
  methods: {
    questResultTypeToString(type)
    {
      switch (type)
      {
        case questResultFormat.number:
          return 'Getal';
        case questResultFormat.time:
          return 'Tijdsduur (hh:mm:ss)';
        case questResultFormat.text:
          return 'Tekst';
      }
      return '';
    }
  }
}